import { useState } from "react";
import { Load } from "../../components/Load";
import { InputDate } from "../../components/InputDate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faLocationDot,
  faPrint,
  faTimes,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { useAdmContext } from "../../hooks/useAdmContext";
import { convertToUs } from "../../utils/dateProvider";
import { api } from "../../services/api";
import { ICidades, IPessoas } from "../../global/types";
import Modal from "react-modal";

import "./style.css";
import { CidadesModal } from "../../modals/CidadesModal";
import { defaultModalStyle } from "../../utils/defaultModalStyle";
import { Input } from "../../components/Input";
import { PessoasModal } from "../../modals/PessoasModal";

type IListCidades = {
  id: string;
  nome: string;
};

export function Relatorio() {
  const { checkToken } = useAdmContext();

  const today = new Date();
  const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
  const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);

  const [loading, setLoading] = useState(false);
  const [txtLoading, setTxtLoading] = useState("");

  const [dataIni, setDataIni] = useState(firstDay);
  const [dataFin, setDataFin] = useState(lastDay);

  const [modalCidades, setModalCidades] = useState(false);
  const [cidadeSelected, setCidadeSelected] = useState<ICidades>(
    {} as ICidades
  );
  const [listCidades, setListCidades] = useState<IListCidades[]>([]);

  const [modalMotorista, setModalMotorista] = useState(false);
  const [motoristaSelected, setMotoristaSelected] = useState<IPessoas>(
    {} as IPessoas
  );

  const handlePrint = async () => {
    setLoading(true);
    setTxtLoading("Verificando login...");

    const canLoad = await checkToken();
    if (!canLoad) return;

    setTxtLoading("Gerando Relatório...");

    const inicio = `${convertToUs(`${dataIni}`)} 00:00:00`;
    const final = `${convertToUs(`${dataFin}`)} 23:59:59`;
    const cidades: string[] = [];

    listCidades.forEach((e) => {
      cidades.push(e.id);
    });

    await api
      .post(
        "entregas/relatorio",
        {
          pesquisa: {
            cidade: cidades,
            id_motorista: motoristaSelected.id
              ? motoristaSelected.id
              : undefined,
            dataBetween: {
              inicio,
              final,
            },
          },
        },
        {
          responseType: "arraybuffer",
          headers: { Accept: "application/pdf" },
        }
      )
      .then((result) => {
        if (!result.data) return;

        const file = new Blob([result.data], { type: "application/pdf" });
        const fileURL = URL.createObjectURL(file);

        const pdfWindow = window.open();

        if (pdfWindow !== null) pdfWindow.location.href = fileURL;
      })
      .catch((err) => {
        console.log(err);

        if (err.response.status !== 401) alert(`${err.response.data.message}`);
      })
      .finally(() => {
        setLoading(false);
        setTxtLoading("");
      });
  };

  const handlePrintCidade = async () => {
    setLoading(true);
    setTxtLoading("Verificando login...");

    const canLoad = await checkToken();
    if (!canLoad) return;

    setTxtLoading("Gerando Relatório...");

    const inicio = `${convertToUs(`${dataIni}`)} 00:00:00`;
    const final = `${convertToUs(`${dataFin}`)} 23:59:59`;
    const cidades: string[] = [];

    listCidades.forEach((e) => {
      cidades.push(e.id);
    });

    await api
      .post(
        "entregas/relatorioCidades",
        {
          pesquisa: {
            cidade: cidades,
            id_motorista: motoristaSelected.id
              ? motoristaSelected.id
              : undefined,
            dataBetween: {
              inicio,
              final,
            },
          },
        },
        {
          responseType: "arraybuffer",
          headers: { Accept: "application/pdf" },
        }
      )
      .then((result) => {
        if (!result.data) return;

        const file = new Blob([result.data], { type: "application/pdf" });
        const fileURL = URL.createObjectURL(file);

        const pdfWindow = window.open();

        if (pdfWindow !== null) pdfWindow.location.href = fileURL;
      })
      .catch((err) => {
        console.log(err);

        if (err.response.status !== 401) alert(`${err.response.data.message}`);
      })
      .finally(() => {
        setLoading(false);
        setTxtLoading("");
      });
  };

  const handlePrintExcel = async () => {
    setLoading(true);
    setTxtLoading("Verificando login...");

    const canLoad = await checkToken();
    if (!canLoad) return;

    setTxtLoading("Gerando Relatório...");

    const inicio = `${convertToUs(`${dataIni}`)} 00:00:00`;
    const final = `${convertToUs(`${dataFin}`)} 23:59:59`;
    const cidades: string[] = [];

    listCidades.forEach((e) => {
      cidades.push(e.id);
    });

    await api
      .post(
        "entregas/relatorioExcel",
        {
          pesquisa: {
            cidade: cidades,
            id_motorista: motoristaSelected.id
              ? motoristaSelected.id
              : undefined,
            dataBetween: {
              inicio,
              final,
            },
          },
        },
        {
          responseType: "arraybuffer",
        }
      )
      .then((result) => {
        if (!result.data) return;

        console.log(result.data);

        const url = window.URL.createObjectURL(new Blob([result.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "relatorio.xlsx");
        document.body.appendChild(link);
        link.click();
      })
      .catch((err) => {
        console.log(err);

        if (err.response.status !== 401) alert(`${err.response.data.message}`);
      })
      .finally(() => {
        setLoading(false);
        setTxtLoading("");
      });
  };

  const handleAddCidade = () => {
    if (!cidadeSelected.id) return;

    const newList: IListCidades[] = [];

    newList.push({
      id: cidadeSelected.id,
      nome: cidadeSelected.nome,
    });

    listCidades.forEach((e) => {
      newList.push(e);
    });

    setCidadeSelected({} as ICidades);

    setListCidades(newList);
  };

  const handleDeleteCidade = (item: IListCidades) => {
    const newList: IListCidades[] = [];

    listCidades.forEach((e) => {
      if (item.id !== e.id) newList.push(e);
    });

    setListCidades(newList);
  };

  return (
    <div id="pgRelatorio">
      {loading && <Load txtLoading={txtLoading} />}

      {!loading && (
        <>
          <div className="painel">
            <p className="title">Filtros</p>

            <div className="bodyFilter">
              <div style={{ width: "32%" }}>
                <label>Data Inicial</label>
                <InputDate onChange={setDataIni} value={dataIni} required />
              </div>

              <div style={{ width: "32%" }}>
                <label>Data Final</label>
                <InputDate onChange={setDataFin} value={dataFin} required />
              </div>

              <div style={{ width: "32%" }}>
                <label>Motorista</label>
                <span className="dvFilterSelect">
                  <Input
                    mask="none"
                    value={motoristaSelected.nome ? motoristaSelected.nome : ""}
                    inputMaskChange={(v) => {}}
                    placeholder="Selecione um motorista"
                    readOnly
                  />
                  {motoristaSelected.nome && (
                    <button
                      className="btn-red"
                      onClick={() => setMotoristaSelected({} as IPessoas)}
                    >
                      <FontAwesomeIcon icon={faTimes} />
                    </button>
                  )}

                  <button
                    className="btn-purple"
                    onClick={() => setModalMotorista(true)}
                  >
                    <FontAwesomeIcon icon={faUser} />
                  </button>
                </span>
              </div>

              <div style={{ width: "32%" }}>
                <label>Cidade</label>
                <span className="dvFilterSelect">
                  <Input
                    mask="none"
                    value={cidadeSelected.nome ? cidadeSelected.nome : ""}
                    inputMaskChange={(v) => {}}
                    placeholder="Selecione uma cidade"
                    readOnly
                  />
                  {cidadeSelected.nome && (
                    <>
                      <button
                        className="btn-red"
                        onClick={() => setCidadeSelected({} as ICidades)}
                      >
                        <FontAwesomeIcon icon={faTimes} />
                      </button>

                      <button
                        className="btn-green"
                        onClick={() => handleAddCidade()}
                      >
                        <FontAwesomeIcon icon={faCheck} />
                      </button>
                    </>
                  )}

                  {!cidadeSelected.nome && (
                    <button
                      className="btn-purple"
                      onClick={() => setModalCidades(true)}
                    >
                      <FontAwesomeIcon icon={faLocationDot} />
                    </button>
                  )}
                </span>
              </div>

              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                  gap: "6px",
                }}
              >
                <label style={{ width: "100%" }}>Cidades Selecionadas</label>
                {listCidades.map((item) => (
                  <div
                    key={item.id}
                    style={{
                      border: 1,
                      borderStyle: "dashed",
                      display: "flex",
                      flexDirection: "row",
                      borderRadius: "8px",
                      padding: "5px 12px",
                      gap: "6px",
                      alignItems: "center",
                    }}
                  >
                    <p>{item.nome}</p>
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={() => handleDeleteCidade(item)}
                    >
                      <FontAwesomeIcon icon={faTimes} />
                    </div>
                  </div>
                ))}
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "6px",
                  margin: "0 auto",
                }}
              >
                <button
                  className="btn-blue"
                  style={{ margin: "0 auto" }}
                  onClick={() => handlePrint()}
                >
                  <FontAwesomeIcon icon={faPrint} />
                  Imprimir
                </button>

                <button
                  className="btn-blue"
                  style={{ margin: "0 auto" }}
                  onClick={() => handlePrintExcel()}
                >
                  <FontAwesomeIcon icon={faPrint} />
                  Imprimir Excel
                </button>

                <button
                  className="btn-green"
                  style={{ margin: "0 auto" }}
                  onClick={() => handlePrintCidade()}
                >
                  <FontAwesomeIcon icon={faPrint} />
                  Imprimir por Cidade
                </button>
              </div>
            </div>
          </div>
        </>
      )}

      <Modal isOpen={modalCidades} style={defaultModalStyle}>
        <CidadesModal
          closeModal={() => setModalCidades(false)}
          handleSelect={(e) => setCidadeSelected(e)}
        />
      </Modal>

      <Modal isOpen={modalMotorista} style={defaultModalStyle}>
        <PessoasModal
          closeModal={() => setModalMotorista(false)}
          handleSelect={(e) => setMotoristaSelected(e)}
        />
      </Modal>
    </div>
  );
}
